module.exports = __webpack_public_path__ + "img/mobile_pink_cloud_2.ba7aee3a.svg";